
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.378 4.434L19.565 2.62a2.126 2.126 0 00-3.003 0L3.078 16.106a.597.597 0 00-.162.308l-.906 4.893a.586.586 0 00.683.683l4.893-.906a.597.597 0 00.308-.162L21.377 7.437c.83-.83.83-2.173 0-3.003zM3.318 20.683l.547-2.96 2.412 2.411-2.96.549zm4.161-1.004L4.321 16.52 15.852 4.988l3.159 3.159L7.479 19.679zM20.55 6.61l-.71.709-3.158-3.159.71-.71a.953.953 0 011.346 0l1.812 1.813a.951.951 0 010 1.347z","fill":"#000"}})])
          )
        }
      }
    